import type { ElementType, ReactNode } from 'react';

export interface RevealProps {
  readonly children: ReactNode;
  /** Thẻ bọc. Mặc định `div`; truyền `li`/`section` khi cần giữ semantic. */
  readonly as?: ElementType;
  readonly className?: string;
}

/**
 * Đánh dấu một khối để `revealAll()` tìm thấy. CHỈ là markup — không hook, không state, không
 * effect. Nhờ vậy nó dùng được cả trong section không hydrate.
 *
 * Chỉ số stagger do `revealAll()` đặt lúc chạy, không phải prop: thứ tự trong DOM mới là thứ tự
 * người dùng thật sự thấy, còn thứ tự render có thể khác.
 */
export function Reveal({ children, as: Tag = 'div', className }: RevealProps) {
  return (
    <Tag data-reveal="" className={className}>
      {children}
    </Tag>
  );
}
